import { render, staticRenderFns } from "./editable-text.vue?vue&type=template&id=934e529c&scoped=true"
import script from "./editable-text.vue?vue&type=script&lang=js"
export * from "./editable-text.vue?vue&type=script&lang=js"
import style0 from "./editable-text.vue?vue&type=style&index=0&id=934e529c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934e529c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('934e529c')) {
      api.createRecord('934e529c', component.options)
    } else {
      api.reload('934e529c', component.options)
    }
    module.hot.accept("./editable-text.vue?vue&type=template&id=934e529c&scoped=true", function () {
      api.rerender('934e529c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-components/editable-text.vue"
export default component.exports